import React, {FC, ReactElement, useCallback, useEffect, useState} from 'react';
import TextFieldWithValidation, {TextFieldWithValidationProps} from "./TextFieldWithValidation";
import {CircularProgress, Grid} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from "@mui/material/IconButton";


export interface TextFieldWithPersistenceProps extends TextFieldWithValidationProps {
    onPersist: (value: string) => Promise<void>
    value?: string
}

export const TextFieldWithPersistence: FC<Omit<TextFieldWithPersistenceProps, "onChange">> = ({value: initialValue, onPersist, ...otherProps}): ReactElement => {
    const [value, setValue] = useState(initialValue);
    const [saveState, setSaveState] = useState<"no_changes" | "need_to_save" | "saving">("no_changes");

    useEffect(() => {
        if (value === initialValue) {
            setSaveState("no_changes");
        }
    }, [value, initialValue])

    const doPersist = useCallback(async () => {
        setSaveState("saving");
        await onPersist(value ?? "");
        setSaveState("no_changes");
    }, [onPersist, value])

    const doCancel = () => {
        setValue(initialValue);
        setSaveState("no_changes");
    }

    const handleValueChanged = useCallback(async (newValue: string) => {
        setValue(newValue);
        setSaveState("need_to_save");
    }, [])

    let changedProps: any = {...otherProps}
    delete changedProps.onPersist;

    // @ts-ignore
    return <TextFieldWithValidation
            {...changedProps}
            disabled={otherProps.disabled || saveState === "saving"}
            value={value}
            onChange={e => handleValueChanged(e.target.value)}
            label={<Grid container alignItems={"center"} spacing={1} style={{minHeight: "2rem"}}>
                <Grid item>
                    {otherProps.label}
                </Grid>
                {saveState === "saving" &&
                        <Grid item>
                            <CircularProgress size={"1rem"}/>
                        </Grid>}
                {saveState === "need_to_save" &&
                        <>
                            <Grid item>
                                <IconButton color={"primary"} style={{padding: 0}} size={"small"} onClick={doPersist}><CheckCircleIcon/></IconButton>
                            </Grid>
                            <Grid item>
                                <IconButton color={"secondary"} style={{padding: 0}} size={"small"} onClick={doCancel}><CancelIcon/></IconButton>
                            </Grid>
                        </>}
            </Grid>}
    />
};